import * as React from 'react';
import { Box } from '@mui/material';
import LandingHero from './components/LandingHero';
import FeaturesSection from './components/FeaturesSection';
import ShowcaseSection from './components/ShowcaseSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Landing() {
  return (
    <Box sx={{ background: '#050505', minHeight: '100vh' }}>
      <LandingHero />
      <FeaturesSection />
      <ShowcaseSection />
      <CTASection />
      <Footer />
    </Box>
  );
}
